const baseStyle = {
  opacity: 0.6,
  borderColor: 'gray',
};

const variantSolid = {
  borderWidth: '4px',
  borderStyle: 'solid',
  borderRadius: '17px',
};

const variantDashed = {
  borderStyle: 'dashed',
};

const variants = {
  solid: variantSolid,
  dashed: variantDashed,
};

const defaultProps = {
  variant: 'solid',
};

export default {
  baseStyle,
  variants,
  defaultProps,
};
